import { createOptionsFrom } from "@/lib/common/Option";

export const SearchOptionsFoilingLabels = {
	Normal: "Normal",
	RainbowFoil: "Rainbow Foil",
	ColdFoil: "Cold Foil"
} as const;

export type SearchOptionsFoiling = keyof typeof SearchOptionsFoilingLabels;

export const SearchOptionsFoilingOptions = createOptionsFrom(SearchOptionsFoilingLabels);
